var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { imageBasePath } from '../../../utils/imagekitBasePath';
import MobNavItems from './MobNavItems';
import NavButtons from './NavButtons';
import NavItems from './NavItems';
var MobNavbar = function (_a) {
    var buttons = _a.buttons, isLoggedIn = _a.isLoggedIn, mobileNavData = _a.mobileNavData, navData = _a.navData, handleSegmentEvents = _a.handleSegmentEvents, logoLink = _a.logoLink, selectedTitle = _a.selectedTitle;
    var _b = __read(useState(false), 2), isMenuOpen = _b[0], setMenuVisiblity = _b[1];
    var _c = __read(useState(false), 2), isOpenLogo = _c[0], setIsOpenLogo = _c[1];
    useEffect(function () {
        if (isMenuOpen || !isLoggedIn)
            setIsOpenLogo(true);
        else
            setIsOpenLogo(false);
    }, [isMenuOpen, isLoggedIn]);
    return (React.createElement("div", { id: "mobile_logged_in_navbar", className: "lfc-w-screen lfc-h-mobileHeaderHeight" },
        React.createElement("div", { className: "lfc-w-full lfc-fixed lfc-z-[9000] !lfc-h-mobileHeaderHeight lfc-left-0 lfc-right-0 lfc-top-0" },
            React.createElement("div", { className: "lfc-w-screen lfc-h-full lfc-bg-white lfc-border-b lfc-border-[#DBDBDB] lfc-shadow-[0px_4px_8px_0px_rgba(67,54,149,0.08)] lfc-flex lfc-gap-4 lfc-justify-between lfc-items-center lfc-py-4" },
                React.createElement("div", { className: "lfc-w-full lfc-flex lfc-gap-2 lfc-items-center lfc-pl-4" },
                    isOpenLogo ? (React.createElement(Image, { src: "".concat(imageBasePath, "/LeapScholar/leap_logo_Psi6P4qMo.svg"), height: 24, width: 124, alt: "leap-scholar-logo", 
                        // eslint-disable-next-line @typescript-eslint/no-misused-promises
                        onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!handleSegmentEvents) return [3 /*break*/, 2];
                                        return [4 /*yield*/, handleSegmentEvents('LS Logo')];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        window.open(logoLink, '_self');
                                        return [2 /*return*/];
                                }
                            });
                        }); } })) : (React.createElement(Image, { src: "".concat(imageBasePath, "/LeapScholar/leap_logo_eGTnLF_EvK.svg"), height: 24, width: 24, alt: "leap-scholar-logo", 
                        // eslint-disable-next-line @typescript-eslint/no-misused-promises
                        onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!handleSegmentEvents) return [3 /*break*/, 2];
                                        return [4 /*yield*/, handleSegmentEvents('LS Logo')];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        window.open(logoLink, '_self');
                                        return [2 /*return*/];
                                }
                            });
                        }); } })),
                    isLoggedIn && !isMenuOpen && (React.createElement("div", { className: "lfc-flex lfc-items-center lfc-gap-4" }, navData.map(function (navItem, index) { return (React.createElement(NavItems, { navItem: navItem, key: index, isLastMenuItem: (navData === null || navData === void 0 ? void 0 : navData.length) - 1 === index, isLoggedIn: isLoggedIn, selectedTitle: selectedTitle, handleSegmentEvents: handleSegmentEvents })); })))),
                React.createElement("div", { className: "lfc-pr-4 lfc-w-10 lfc-flex lfc-items-center lfc-justify-center" },
                    React.createElement(Image, { src: isMenuOpen ? "".concat(imageBasePath, "/close-btn.svg") : "".concat(imageBasePath, "/hamburger.svg"), height: 24, width: 24, alt: "hamburger-menu", className: "lfc-w-6 lfc-h-6", 
                        // eslint-disable-next-line @typescript-eslint/no-misused-promises
                        onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        setMenuVisiblity(function (prev) { return !prev; });
                                        if (!handleSegmentEvents) return [3 /*break*/, 2];
                                        return [4 /*yield*/, handleSegmentEvents('Header Hamburger')];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); } }))),
            isMenuOpen && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-fixed lfc-top-[58px] lfc-pb-[155px] lfc-left-0 lfc-bg-white lfc-overflow-y-scroll" }, mobileNavData === null || mobileNavData === void 0 ? void 0 : mobileNavData.map(function (navItem, index) { return (React.createElement(MobNavItems, { navItem: navItem, isLoggedIn: isLoggedIn, key: index, handleSegmentEvents: handleSegmentEvents })); })),
                !isLoggedIn && (React.createElement("div", { className: "lfc-fixed lfc-bg-white lfc-left-0 lfc-bottom-0 lfc-w-full lfc-px-4 lfc-py-5 lfc-border lfc-border-[#CBCAD5] lfc-shadow-[0px_0px_4px_-2px_rgba(16,24,40,0.06),0px_-2px_8px_-2px_rgba(16,24,40,0.10)]" },
                    React.createElement(NavButtons, { navButtons: buttons, handleSegmentEvents: handleSegmentEvents }))))))));
};
export default MobNavbar;
//# sourceMappingURL=MobNavbar.js.map